import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  OnInit,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { provideNativeDateAdapter } from '@angular/material/core';
import { LocalCacheService } from '../../services/localCache.service';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { Router } from '@angular/router';
import { GlobalService } from '../../services/global.service';
import { environment } from '../../../environments/environment';
import { GAService } from '../../services/ga.service';
import { AgePipe } from '../../utils/age.pipe';
import { PDSService } from '../../services/pds.service';
import { BrowserOnlyDirective } from '../../directive/browser-only.directive';
import { DateService } from '../../services/date.service';

@Component({
  selector: 'payment-confirmation',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    FooterComponent,
    AgePipe,
    BrowserOnlyDirective,
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './payment-confirmation.component.html',
  styleUrl: './payment-confirmation.component.scss',
})
export class PaymentConfirmationComponent implements OnInit, AfterViewInit {
  isPaymentLoading: boolean = false;
  quoteDetail: any;
  quoteEnquiry: any;
  travelerDetails: any;
  policyNumber: any;
  selectedCover: any;
  goAdminLink: string = '';
  agentGuid: string = '';
  partnerCode: string = '';
  public travelSummary: any = {};
  public hasAdult2: boolean = false;

  constructor(
    private localCacheService: LocalCacheService,
    private router: Router,
    private globalService: GlobalService,
    private gaService: GAService,
    public pdsService: PDSService,
    private dateService: DateService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    if (!this.globalService.checkAndValidatePage(5, false)) {
      this.router.navigate(['/error']);
    }
    this.quoteDetail = this.localCacheService.getSessionStorage('quoteDetail');
    if (!this.quoteDetail) {
      this.router.navigate(['/']);
      return;
    }
    this.quoteEnquiry =
      this.localCacheService.getSessionStorage('quoteEnquiry');
    this.selectedCover =
      this.localCacheService.getSessionStorage('selectedCoverDetail') || {};
    this.travelerDetails =
      this.localCacheService.getSessionStorage('travelerDetails');
    const paymentInfo = this.localCacheService.getSessionStorage('paymentInfo');
    if (paymentInfo) {
      const paymentInfoObj = JSON.parse(paymentInfo);
      this.policyNumber = paymentInfoObj.policyNumber;
    } else {
      this.policyNumber = null;
    }
    this.getInsuredTravelerDetails();
    this.agentGuid = this.localCacheService.getSessionStorage('agentGuid');
    if (this.agentGuid) {
      const paymentInfoObj = JSON.parse(paymentInfo);
      this.goAdminLink =
        environment.PASUrl +
        '/policy-detail?policyguid=' +
        paymentInfoObj.policyGuid;
    }
    this.gaService.sendPuerchaseEvent();
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.localCacheService.clearAllSession();
    }
  }

  getInsuredTravelerDetails() {
    const { ages, travelers } = this.quoteDetail;

    this.travelSummary.dependentsInfo = [];
    travelers.forEach((element: any) => {
      if (element.role === 'primary') {
        this.travelSummary.adult1 = {
          name: `${element.firstName} ${element.lastName}`,
          dateOfBirth: element.dateOfBirth,
        };
      } else if (element.role === 'secondary') {
        this.travelSummary.adult2 = {
          name: `${element.firstName} ${element.lastName}`,
          dateOfBirth: element.dateOfBirth,
        };
      } else if (element.role === 'dependent') {
        const tempDependent = {
          name: `${element.firstName} ${element.lastName}`,
          dateOfBirth: element.dateOfBirth,
        };

        this.travelSummary.dependentsInfo.push(tempDependent);
      }
    });

    this.hasAdult2 =
      this.travelSummary.adult2 && this.travelSummary.adult2.name
        ? true
        : false;
  }

  get travelDays() {
    const days = this.dateService.diffInDaysInclusive(
      this.quoteEnquiry?.return,
      this.quoteEnquiry?.depart,
    );
    return days;
  }

  get countryNames(): string {
    return this.quoteEnquiry?.travelDestination
      .map((country: any) => country.countryName)
      .join(', ');
  }

  get formattedInvoiceDate(): string {
    const parsedDate = this.dateService.getTodayDateDDMMYY();
    return parsedDate.isValid()
      ? parsedDate.format('D MMMM YYYY')
      : 'Invalid date';
  }
}
